import * as ConcernedViewActions from './concerned-view.actions'

export { ConcernedViewActions }